// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/img/Checkbox.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrijavnicaContainer_container__Kt\\+j8 {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
  gap: 16px;
  width: 100%;
  padding-bottom: 30px;
}
.PrijavnicaContainer_backRow__qu0vq {
  gap: 20px;
  transition: -webkit-text-decoration 300ms ease-in-out;
  transition: text-decoration 300ms ease-in-out;
  transition: text-decoration 300ms ease-in-out, -webkit-text-decoration 300ms ease-in-out;
}
.PrijavnicaContainer_polazniciRow__VP-zT {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  justify-content: flex-start;
  margin-bottom: -24px;
  margin-top: 16px;
}
.PrijavnicaContainer_exportBtn__JiiTb {
  border: 1px solid #d1d9e2;
  background-color: transparent;
  padding: 8px 16px 8px 16px;
  border-radius: 4px;
  gap: 8px;
  transition: background-color 300ms ease-in-out;
}
.PrijavnicaContainer_exportBtn__JiiTb:hover {
  background-color: #e6e5e5;
  cursor: pointer;
}
.PrijavnicaContainer_backRow__qu0vq,
.PrijavnicaContainer_prijavaBtn__Z7iHr,
.PrijavnicaContainer_odjavaBtn__LvD2P,
.PrijavnicaContainer_editBtn__ebqAM,
.PrijavnicaContainer_disabledBtn__ieFmD,
.PrijavnicaContainer_exportBtn__JiiTb,
.PrijavnicaContainer_btnRow__Q3uLP {
  display: flex;
  align-items: center;
  justify-content: center;
}
.PrijavnicaContainer_btnRow__Q3uLP {
  gap: 28px;
}
.PrijavnicaContainer_backRow__qu0vq:hover {
  text-decoration: underline;
  cursor: pointer;
}
.PrijavnicaContainer_backSpan__of138,
.PrijavnicaContainer_title__POI\\+y,
.PrijavnicaContainer_prijavaBtn__Z7iHr,
.PrijavnicaContainer_odjavaBtn__LvD2P,
.PrijavnicaContainer_label__9AyH\\+,
.PrijavnicaContainer_editBtn__ebqAM,
.PrijavnicaContainer_disabledBtn__ieFmD,
.PrijavnicaContainer_exportBtn__JiiTb {
  font-family: Inter;
  font-weight: 600;
  text-align: left;
}
.PrijavnicaContainer_backSpan__of138,
.PrijavnicaContainer_prijavaBtn__Z7iHr,
.PrijavnicaContainer_odjavaBtn__LvD2P,
.PrijavnicaContainer_label__9AyH\\+,
.PrijavnicaContainer_editBtn__ebqAM,
.PrijavnicaContainer_disabledBtn__ieFmD,
.PrijavnicaContainer_exportBtn__JiiTb {
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.001em;
}
.PrijavnicaContainer_backSpan__of138,
.PrijavnicaContainer_prijavaBtn__Z7iHr,
.PrijavnicaContainer_label__9AyH\\+,
.PrijavnicaContainer_disabledBtn__ieFmD,
.PrijavnicaContainer_exportBtn__JiiTb {
  color: #5f6d7e;
}
.PrijavnicaContainer_title__POI\\+y {
  font-size: 28px;
  line-height: 36px;
  letter-spacing: 0.0015em;
  color: #4d4d4d;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-top: 60px;
}

.PrijavnicaContainer_pojedinaSekcijaImage__Lfs9v {
  width: 230px;
  height: 175px;
  border-radius: 8px;
  border: 4px solid #fff;
  margin-left: 40px;
  transform: translateY(30px);
  object-fit: cover;
}
.PrijavnicaContainer_pojedinaImageContainer__1Wlv0 {
  width: 100%;
  height: 175px;
  border-radius: 4px;
  background: #ebe6dd;
  z-index: -1;
}
.PrijavnicaContainer_prijavaBtn__Z7iHr,
.PrijavnicaContainer_odjavaBtn__LvD2P,
.PrijavnicaContainer_editBtn__ebqAM,
.PrijavnicaContainer_disabledBtn__ieFmD {
  height: 40px;
  padding: 30px 80px 30px 80px;
  border: none;
  text-align: center;
  color: #ffffff;
  border-radius: 4px;
  transition: backgroundColor 300ms ease-in-out;
  cursor: pointer;
}
.PrijavnicaContainer_editBtn__ebqAM {
  background-color: #ffffff;
  border: 1px solid #d1d9e2;
  color: #5f6d7e;
}
.PrijavnicaContainer_editBtn__ebqAM:hover {
  background-color: #d1d9e2;
}
.PrijavnicaContainer_prijavaBtn__Z7iHr {
  background-color: #cb9c2d;
}
.PrijavnicaContainer_prijavaBtn__Z7iHr:hover {
  background-color: #d8dbdf;
  color: #4e4e4e;
}
.PrijavnicaContainer_disabledBtn__ieFmD {
  background-color: #d8dbdf;
  color: #4e4e4e;
  cursor: not-allowed;
  pointer-events: none;
}
.PrijavnicaContainer_infoContainer__Pjvrw {
  width: 70%;
  padding-bottom: 40px;
}
.PrijavnicaContainer_odjavaBtn__LvD2P {
  background-color: #cb2d2d;
}
.PrijavnicaContainer_odjavaBtn__LvD2P:hover {
  background-color: #691a1a;
}
.PrijavnicaContainer_label__9AyH\\+ {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.PrijavnicaContainer_checkboxInput__2FiS4 {
  display: none;
}
.PrijavnicaContainer_checkboxInput__2FiS4:checked + .PrijavnicaContainer_checkboxCustom__VqVE2 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
}
.PrijavnicaContainer_checkboxCustom__VqVE2 {
  width: 20px;
  height: 20px;
  border: 1px solid #5f6d7e;
  background-color: white;
  margin-right: 10px;
  border-radius: 100px;
}
.PrijavnicaContainer_topRow__IKBjF {
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
}
.PrijavnicaContainer_opisiWrapper__hsuYT {
  flex-direction: column;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  width: 100%;
}
@media screen and (max-width: 1526px) {
  .PrijavnicaContainer_infoContainer__Pjvrw {
    width: 80%;
  }
}
@media screen and (min-width: 1527px) {
  .PrijavnicaContainer_infoContainer__Pjvrw {
    width: 70%;
  }
}
@media screen and (max-width: 1140px) {
  .PrijavnicaContainer_infoContainer__Pjvrw {
    width: 70%;
  }
}

@media screen and (max-width: 870px) {
  .PrijavnicaContainer_infoContainer__Pjvrw {
    width: 80%;
  }
}
@media screen and (max-width: 680px) {
  .PrijavnicaContainer_infoContainer__Pjvrw {
    width: 60%;
  }
  .PrijavnicaContainer_pojedinaSekcijaImage__Lfs9v {
    width: 200px;
    height: 150px;
    transform: translateY(50px);
    margin-left: 25px;
  }
  .PrijavnicaContainer_prijavaBtn__Z7iHr,
  .PrijavnicaContainer_odjavaBtn__LvD2P {
    padding: 25px 40px;
  }
}
@media screen and (max-width: 570px) {
  .PrijavnicaContainer_infoContainer__Pjvrw {
    width: 70%;
  }
}
@media screen and (max-width: 480px) {
  .PrijavnicaContainer_infoContainer__Pjvrw {
    width: 82%;
  }
  .PrijavnicaContainer_pojedinaSekcijaImage__Lfs9v {
    width: 190px;
    height: 140px;
    transform: translateY(60px);
    margin-left: 20px;
  }
}
@media screen and (max-width: 420px) {
  .PrijavnicaContainer_infoContainer__Pjvrw {
    width: 90%;
  }
}
@media screen and (max-width: 380px) {
  .PrijavnicaContainer_infoContainer__Pjvrw {
    width: 95%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/PojedinaPrijavnica/PrijavnicaContainer/PrijavnicaContainer.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,qDAA6C;EAA7C,6CAA6C;EAA7C,wFAA6C;AAC/C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,8CAA8C;AAChD;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;;;;;;;EAOE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,SAAS;AACX;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;;;;;;;;EAQE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;;;;;;EAOE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;;;;;EAKE,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;AACA;;;;EAIE,YAAY;EACZ,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,6CAA6C;EAC7C,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,2EAA2E;AAC7E;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,iBAAiB;EACnB;EACA;;IAEE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,iBAAiB;EACnB;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  justify-content: center;\n  gap: 16px;\n  width: 100%;\n  padding-bottom: 30px;\n}\n.backRow {\n  gap: 20px;\n  transition: text-decoration 300ms ease-in-out;\n}\n.polazniciRow {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n  justify-content: flex-start;\n  margin-bottom: -24px;\n  margin-top: 16px;\n}\n.exportBtn {\n  border: 1px solid #d1d9e2;\n  background-color: transparent;\n  padding: 8px 16px 8px 16px;\n  border-radius: 4px;\n  gap: 8px;\n  transition: background-color 300ms ease-in-out;\n}\n.exportBtn:hover {\n  background-color: #e6e5e5;\n  cursor: pointer;\n}\n.backRow,\n.prijavaBtn,\n.odjavaBtn,\n.editBtn,\n.disabledBtn,\n.exportBtn,\n.btnRow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.btnRow {\n  gap: 28px;\n}\n.backRow:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n.backSpan,\n.title,\n.prijavaBtn,\n.odjavaBtn,\n.label,\n.editBtn,\n.disabledBtn,\n.exportBtn {\n  font-family: Inter;\n  font-weight: 600;\n  text-align: left;\n}\n.backSpan,\n.prijavaBtn,\n.odjavaBtn,\n.label,\n.editBtn,\n.disabledBtn,\n.exportBtn {\n  font-size: 16px;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n}\n.backSpan,\n.prijavaBtn,\n.label,\n.disabledBtn,\n.exportBtn {\n  color: #5f6d7e;\n}\n.title {\n  font-size: 28px;\n  line-height: 36px;\n  letter-spacing: 0.0015em;\n  color: #4d4d4d;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding-top: 60px;\n}\n\n.pojedinaSekcijaImage {\n  width: 230px;\n  height: 175px;\n  border-radius: 8px;\n  border: 4px solid #fff;\n  margin-left: 40px;\n  transform: translateY(30px);\n  object-fit: cover;\n}\n.pojedinaImageContainer {\n  width: 100%;\n  height: 175px;\n  border-radius: 4px;\n  background: #ebe6dd;\n  z-index: -1;\n}\n.prijavaBtn,\n.odjavaBtn,\n.editBtn,\n.disabledBtn {\n  height: 40px;\n  padding: 30px 80px 30px 80px;\n  border: none;\n  text-align: center;\n  color: #ffffff;\n  border-radius: 4px;\n  transition: backgroundColor 300ms ease-in-out;\n  cursor: pointer;\n}\n.editBtn {\n  background-color: #ffffff;\n  border: 1px solid #d1d9e2;\n  color: #5f6d7e;\n}\n.editBtn:hover {\n  background-color: #d1d9e2;\n}\n.prijavaBtn {\n  background-color: #cb9c2d;\n}\n.prijavaBtn:hover {\n  background-color: #d8dbdf;\n  color: #4e4e4e;\n}\n.disabledBtn {\n  background-color: #d8dbdf;\n  color: #4e4e4e;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n.infoContainer {\n  width: 70%;\n  padding-bottom: 40px;\n}\n.odjavaBtn {\n  background-color: #cb2d2d;\n}\n.odjavaBtn:hover {\n  background-color: #691a1a;\n}\n.label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n.checkboxInput {\n  display: none;\n}\n.checkboxInput:checked + .checkboxCustom {\n  background: url(\"../../../assets/img/Checkbox.png\") center center no-repeat;\n}\n.checkboxCustom {\n  width: 20px;\n  height: 20px;\n  border: 1px solid #5f6d7e;\n  background-color: white;\n  margin-right: 10px;\n  border-radius: 100px;\n}\n.topRow {\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n.opisiWrapper {\n  flex-direction: column;\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  width: 100%;\n}\n@media screen and (max-width: 1526px) {\n  .infoContainer {\n    width: 80%;\n  }\n}\n@media screen and (min-width: 1527px) {\n  .infoContainer {\n    width: 70%;\n  }\n}\n@media screen and (max-width: 1140px) {\n  .infoContainer {\n    width: 70%;\n  }\n}\n\n@media screen and (max-width: 870px) {\n  .infoContainer {\n    width: 80%;\n  }\n}\n@media screen and (max-width: 680px) {\n  .infoContainer {\n    width: 60%;\n  }\n  .pojedinaSekcijaImage {\n    width: 200px;\n    height: 150px;\n    transform: translateY(50px);\n    margin-left: 25px;\n  }\n  .prijavaBtn,\n  .odjavaBtn {\n    padding: 25px 40px;\n  }\n}\n@media screen and (max-width: 570px) {\n  .infoContainer {\n    width: 70%;\n  }\n}\n@media screen and (max-width: 480px) {\n  .infoContainer {\n    width: 82%;\n  }\n  .pojedinaSekcijaImage {\n    width: 190px;\n    height: 140px;\n    transform: translateY(60px);\n    margin-left: 20px;\n  }\n}\n@media screen and (max-width: 420px) {\n  .infoContainer {\n    width: 90%;\n  }\n}\n@media screen and (max-width: 380px) {\n  .infoContainer {\n    width: 95%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PrijavnicaContainer_container__Kt+j8`,
	"backRow": `PrijavnicaContainer_backRow__qu0vq`,
	"polazniciRow": `PrijavnicaContainer_polazniciRow__VP-zT`,
	"exportBtn": `PrijavnicaContainer_exportBtn__JiiTb`,
	"prijavaBtn": `PrijavnicaContainer_prijavaBtn__Z7iHr`,
	"odjavaBtn": `PrijavnicaContainer_odjavaBtn__LvD2P`,
	"editBtn": `PrijavnicaContainer_editBtn__ebqAM`,
	"disabledBtn": `PrijavnicaContainer_disabledBtn__ieFmD`,
	"btnRow": `PrijavnicaContainer_btnRow__Q3uLP`,
	"backSpan": `PrijavnicaContainer_backSpan__of138`,
	"title": `PrijavnicaContainer_title__POI+y`,
	"label": `PrijavnicaContainer_label__9AyH+`,
	"pojedinaSekcijaImage": `PrijavnicaContainer_pojedinaSekcijaImage__Lfs9v`,
	"pojedinaImageContainer": `PrijavnicaContainer_pojedinaImageContainer__1Wlv0`,
	"infoContainer": `PrijavnicaContainer_infoContainer__Pjvrw`,
	"checkboxInput": `PrijavnicaContainer_checkboxInput__2FiS4`,
	"checkboxCustom": `PrijavnicaContainer_checkboxCustom__VqVE2`,
	"topRow": `PrijavnicaContainer_topRow__IKBjF`,
	"opisiWrapper": `PrijavnicaContainer_opisiWrapper__hsuYT`
};
export default ___CSS_LOADER_EXPORT___;
